var _desc, _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextToImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.2.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 100 100)",
    id: "a029ea01-2495-4c1e-9fd1-0f46ed60d4fc"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -100,
    y: -100,
    rx: 0,
    ry: 0,
    width: 200,
    height: 200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)",
    id: "14f17815-bd2a-48a8-b274-da467d55c5bc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.27 0 0 0.27 98.99 31.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-600.05, -269.49)",
    d: "M 891.62348 313.02059 L 308.47961 313.02059 C 291.9585326340747 313.00192452975597 278.5702099499816 299.61359737216117 278.55154999999996 283.09252000000004 L 278.55154999999996 255.88519 C 278.5702099499816 239.36411262783886 291.9585326340747 225.97578547024403 308.47961 225.95712 L 891.62348 225.95712 C 908.1445612711673 225.97577996061418 921.5328900393858 239.3641087288327 921.55155 255.88519 L 921.55155 283.09252 C 921.5328900393858 299.6136012711673 908.1445612711673 313.00193003938585 891.62348 313.02059 Z M 308.47961 227.77094 C 292.9598345272664 227.78853621862697 280.3829606983736 240.36541452100857 280.36537 255.88519 L 280.36537 283.09252 C 280.3829606983736 298.6122954789914 292.9598345272664 311.18917378137303 308.47961 311.20677 L 891.62348 311.20677 C 907.1432554727336 311.18917378137303 919.7201293016263 298.6122954789914 919.73772 283.09252000000004 L 919.73772 255.88519 C 919.7201293016263 240.36541452100857 907.1432554727335 227.78853621862697 891.62348 227.77094 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.27 0 0 0.27 84.72 31.48)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -210.855,
    y: -17.23,
    rx: 17.23129,
    ry: 17.23129,
    width: 421.71,
    height: 34.46
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.27 0 0 0.27 169.67 34.76)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(108,99,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-855.24, -281.4)",
    d: "M 864.86391 288.10449 C 864.0041601609539 289.33231034085793 862.3118682411117 289.6307257106433 861.08401 288.77103 L 846.27734 278.46828 C 845.0494894984812 277.6085493756334 844.7510693756334 275.91623050151884 845.6107999999999 274.68838000000005 C 846.4705306243666 273.4605294984812 848.1628494984811 273.1621093756334 849.3906999999999 274.02184 L 864.19737 284.32459 C 865.4251953821861 285.18433662736174 865.7236115464306 286.8766330525239 864.86391 288.10449 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.27 0 0 0.27 163.37 30.35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(108,99,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-832.27, -265.35)",
    d: "M 848.054 276.39907 C 841.9508338146533 285.1155014312527 829.937176535082 287.2339720111439 821.2207445378648 281.1308066340975 C 812.5043125406477 275.027641257051 810.3858408466948 263.01398417393176 816.4890054154409 254.29755161075022 C 822.5921699841871 245.58111904756868 834.6058268708542 243.4626462395542 843.32226 249.56581 C 852.0277150315422 255.67596645052006 854.1444584436067 267.67982260686244 848.054 276.39907 Z M 820.43463 257.06024 C 815.8572901580337 263.5975495582946 817.4461512360117 272.6077521097775 823.9834527875418 277.1851033869009 C 830.5207543390719 281.7624546640243 839.5309596698016 280.1736093468361 844.1083223820682 273.63631580209045 C 848.6856850943348 267.0990222573448 847.0968555379411 258.08881414739574 840.55957 253.51144000000002 C 834.0201361668334 248.94357039578333 825.0172217254883 250.53112847139914 820.43461 257.06024 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16 0 0 4.16 100 118.39)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.08 0 0 0.08 0.03 -3.43)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-836.9, -307.88)",
    d: "M 1060.38951 180.02225 L 1060.38951 435.74579 C 1060.3900803100985 437.45274538699624 1059.7125404568515 439.0900145778603 1058.505942054924 440.2974156358834 C 1057.2993436529966 441.5048166939065 1055.6625253888228 442.18344518296203 1053.95557 442.18401 L 619.8445700000001 442.18401 C 619.5355241240394 442.18641531221806 619.2268378919633 442.1624079814637 618.9218800000001 442.11225 C 615.75627239495 441.6564411249134 613.4064101860306 438.94404471720696 613.4063500000001 435.74579 L 613.4063500000001 180.02225 C 613.4057770368504 178.31531317789134 614.0833069712926 176.67806073772005 615.2898903705006 175.4706709316868 C 616.4964737697086 174.26328112565358 618.1332731760558 173.5846574683193 619.8402100000001 173.58409 L 1053.95128 173.58409 C 1055.6582327353656 173.58351438379682 1057.295501490854 174.2610480958229 1058.5029044246269 175.46764087204113 C 1059.7103073583999 176.67423364825936 1060.3889398804015 178.31104726278983 1060.38951 180.018 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.08 0 0 0.08 -8.97 -6.43)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(108,99,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 56.48299
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.08 0 0 0.08 -6.02 -1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-760.9, -327.34)",
    d: "M 899.95742 443.20921 L 622.8688 443.20921 C 622.5218575941793 443.21373201701203 622.175236271059 443.1862826959348 621.8333299999999 443.12721 L 752.88347 216.12946 C 754.5118102544783 213.25129822061137 757.5628673960672 211.4719498938395 760.869725 211.4719498938395 C 764.1765826039328 211.4719498938395 767.2276397455217 213.25129822061137 768.85598 216.12946 L 856.80708 368.46254 L 861.0206400000001 375.75169999999997 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.08 0 0 0.08 1.72 4.85)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    vectorEffect: "non-scaling-stroke",
    points: "47.3,37.37 -47.3,37.37 -0.86,-30.08 2.48,-34.94 4.15,-37.37 8.37,-30.08 47.3,37.37 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.08 0 0 0.08 8.28 1.04)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-934.41, -360.79)",
    d: "M 1054.23833 443.20921 L 814.57943 443.20921 L 861.02064 375.75166 L 864.3627299999999 370.89221000000003 L 924.87973 282.98209 C 928.84719 277.22054 938.39173 276.86173 943.05635 281.89541 C 943.3696373536696 282.23874943395657 943.6607176670767 282.60171219225373 943.92782 282.98209 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.08 0 0 0.08 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-837.2, -351.25)",
    d: "M 1084.81325 163.872 C 1081.8641711672922 155.7078285452054 1074.120232106099 150.2628654594848 1065.43976 150.25 L 608.95181 150.25 C 603.4918546021358 150.24788208898673 598.2549165411099 152.41590298658485 594.3941447638474 156.27667476384735 C 590.5333729865849 160.13744654110982 588.3653520889867 165.37438460213582 588.36747 170.83434 L 588.36747 531.66566 C 588.3835475642672 543.0274108586327 597.5900591413672 552.2339224357328 608.95181 552.25 L 1065.43981 552.25 C 1076.801560858633 552.2339224357329 1086.008072435733 543.0274108586328 1086.0241500000002 531.66566 L 1086.0241500000002 170.83434 C 1086.0280562089426 168.46083657144618 1085.6182927227674 166.104809888536 1084.81325 163.872 Z M 1083.60241 531.6656700000001 C 1083.5902108727905 541.6915672200366 1075.4656572200365 549.8161208727905 1065.43976 549.8283200000001 L 608.95181 549.8283200000001 C 598.9259127799635 549.8161208727905 590.8013591272096 541.6915672200366 590.78916 531.6656700000001 L 590.78916 170.83434 C 590.8013591272096 160.80844277996346 598.9259127799635 152.68388912720957 608.95181 152.67169 L 1065.43981 152.67169 C 1075.4657072200366 152.68388912720954 1083.5902608727906 160.80844277996346 1083.60246 170.83433999999997 Z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextToImage);
export default __webpack_public_path__ + "static/media/text-to-image.657acce7fd298d3d4fb81d2e6b434ab5.svg";
export { ForwardRef as ReactComponent };